import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20football%20stadium%20atmosphere%20with%20dramatic%20green%20pitch%20lighting%2C%20artistic%20sports%20photography%20style%20with%20motion%20blur%20effects%2C%20dark%20stadium%20background%20with%20spotlights%20illuminating%20the%20field%2C%20energy%20and%20passion%20of%20football%2C%20professional%20sports%20aesthetic%20with%20rich%20contrast%20and%20deep%20shadows&width=1800&height=900&seq=kaiyun-hero-bg&orientation=landscape"
          alt="开云足球 - 极致足球体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-sm font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            <span>2026 全新升级 · 极致足球体验</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-4 tracking-tight leading-tight">
            {heroData.title}
            <span className="block text-accent-400 mt-2">{heroData.subtitle}</span>
          </h1>

          <p className="text-background-200/90 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            {heroData.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to={heroData.ctaLink}
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full border-2 border-background-300/40 text-background-200 font-semibold text-sm md:text-base hover:bg-background-50/10 hover:border-background-200/60 transition-all duration-200 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <p className="mt-6 text-background-400 text-xs">
            <i className="ri-user-line mr-1.5"></i>
            {heroData.ctaSubtext}
          </p>
        </div>
      </div>
    </section>
  );
}